import type { WoodTypeContainerDto, WoodTypeDto } from "../../generated/client/octalog-service";

import { useGetWoodTypes } from "./useGetWoodTypes";
import { useIdToNameTranslator } from "./useIdToNameTranslator";

/**
 * Hook to get a function that translates a wood type ID to its translated name.
 * Fetches wood types using `useGetWoodTypes`.
 *
 * @returns {(woodTypeId: number | undefined) => string | number} Function to translate the ID.
 */
export const useWoodTypeIdTranslator = (): ((woodTypeId: number | undefined) => string | number) => {
  const woodTypesQuery = useGetWoodTypes();

  return useIdToNameTranslator<WoodTypeContainerDto, WoodTypeDto, "woodTypeId", "name">(
    woodTypesQuery,
    (data) => data?.woodTypes, // Extractor function
    "woodTypeId",
    "name",
  );
};
